export default function Marquee({ items }) {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center" aria-hidden={key === 1}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display uppercase text-xl md:text-3xl tracking-wide text-white/90 px-6 md:px-10 whitespace-nowrap">
            {item}
          </span>
          <span className="text-gold text-lg md:text-2xl" aria-hidden="true">✦</span>
        </span>
      ))}
    </div>
  );
  return (
    <div className="overflow-hidden border-y border-white/10 bg-panel/60 py-4 md:py-6">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => row(k))}
      </div>
    </div>
  );
}
